import { Paintbrush, Home, Sparkles, Layers, Building2 } from "lucide-react";

export const PHONE = "(775) 745-8288";
export const PHONE_HREF = "tel:+17757458288";
export const EMAIL = "TEOS.PAINTINGLLC@GMAIL.COM";
export const EMAIL_HREF = "mailto:TEOS.PAINTINGLLC@GMAIL.COM";
export const LICENSE = "NV License #0095567";

export const scrollToSection = (href) => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(href, { offset: -70, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "HOME", href: "#home" },
  { label: "SERVICES", href: "#services" },
  { label: "OUR WORK", href: "#work" },
  { label: "ABOUT", href: "#about" },
  { label: "CONTACT", href: "#contact" },
];

export const SERVICES = [
  {
    icon: Paintbrush,
    slug: "interior",
    title: "INTERIOR PAINTING",
    desc: "Refresh your home with clean lines, beautiful finishes and professional attention to detail.",
  },
  {
    icon: Home,
    slug: "exterior",
    title: "EXTERIOR PAINTING",
    desc: "Protect and transform your property with a professional exterior finish.",
  },
  {
    icon: Sparkles,
    slug: "cabinets",
    title: "CABINET REFINISHING",
    desc: "Transform your kitchen without the cost of completely replacing your cabinets.",
  },
  {
    icon: Layers,
    slug: "fence-deck",
    title: "FENCE & DECK STAINING",
    desc: "Restore and protect your outdoor wood surfaces with professional staining.",
  },
  {
    icon: Building2,
    slug: "commercial",
    title: "COMMERCIAL & RESIDENTIAL",
    desc: "Professional painting solutions for homes, businesses and properties of all sizes.",
  },
];

export const SLIDER_PROJECTS = [
  {
    slug: "cabinet-refinishing",
    title: "Cabinet Refinishing",
    location: "Kitchen Transformation · Reno, NV",
    desc: "Honey-oak cabinets refinished to a soft, modern sage — a brand-new kitchen without the remodel.",
    before: "/assets/kitchen_before.webp",
    after: "/assets/kitchen_after.webp",
    bakedLabels: true,
  },
  {
    slug: "exterior-painting",
    title: "Exterior Painting",
    location: "Full Exterior Repaint · Sparks, NV",
    desc: "Complete exterior repaint with crisp trim — curb appeal that protects against the high-desert sun.",
    before: "/assets/work_exterior_before.webp",
    after: "/assets/work_exterior_after.webp",
    bakedLabels: true,
  },
  {
    slug: "door-refinishing",
    title: "Door Refinishing",
    location: "Entry Door Refinish · Carson City, NV",
    desc: "Faded entry door refinished to a deep, rich espresso for a striking first impression.",
    before: "/assets/work_door_before.webp",
    after: "/assets/work_door_after.webp",
    bakedLabels: true,
  },
  {
    slug: "house-painting",
    title: "House Painting",
    location: "Full Exterior Color Change · Northern Nevada",
    desc: "From dated beige to a deep, modern forest green with crisp dark trim — a complete curb-appeal transformation.",
    before: "/assets/work_house2_before.webp",
    after: "/assets/work_house2_after.webp",
    bakedLabels: true,
  },
  {
    slug: "stucco-repaint",
    title: "Stucco Exterior Repaint",
    location: "Full Prep & Repaint · Northern Nevada",
    desc: "Faded stucco fully masked, prepped and resprayed to a clean, bright finish — windows and trim protected every step of the way.",
    before: "/assets/work_stucco_before.webp",
    after: "/assets/work_stucco_after.webp",
    bakedLabels: false,
  },
  {
    slug: "trim-repaint",
    title: "Exterior & Trim Repaint",
    location: "Siding, Trim & Garage Door · Northern Nevada",
    desc: "Careful masking and prep, then warm tan siding set off by rich espresso-brown trim and a refinished garage door.",
    before: "/assets/work_trim_before.webp",
    after: "/assets/work_trim_after.webp",
    bakedLabels: false,
  },
];

export const FENCE_PAIR = {
  title: "Fence Staining",
  location: "Backyard Fence Restoration · Reno, NV",
  desc: "Weathered cedar brought back to life with a rich, protective stain that will last for years.",
  before: "/assets/fence_before.webp",
  after: "/assets/fence_after.webp",
};

export const GALLERY = [
  { src: "/assets/work_trim_after.webp", title: "Exterior & Trim Repaint — After", cat: "Exterior Painting" },
  { src: "/assets/work_trim_before.webp", title: "Exterior & Trim Repaint — Masked & Prepped", cat: "Exterior Painting" },
  { src: "/assets/work_stucco_after.webp", title: "Stucco Repaint — After", cat: "Exterior Painting" },
  { src: "/assets/work_stucco_before.webp", title: "Stucco Repaint — Masked & Prepped", cat: "Exterior Painting" },
  { src: "/assets/work_house2_after.webp", title: "Exterior Color Change — After", cat: "House Painting" },
  { src: "/assets/gallery_house2_front.webp", title: "Exterior Color Change — Before", cat: "House Painting" },
  { src: "/assets/gallery_house2_side.webp", title: "Side Wall — Before", cat: "House Painting" },
  { src: "/assets/gallery_house2_back.webp", title: "Back Wall — Before", cat: "House Painting" },
  { src: "/assets/kitchen_after.webp", title: "Cabinet Refinishing — After", cat: "Cabinet Refinishing" },
  { src: "/assets/fence_after.webp", title: "Fence Staining — After", cat: "Fence Staining" },
  { src: "/assets/gallery_island.webp", title: "Custom Kitchen Island Finish", cat: "Cabinet Refinishing" },
  { src: "/assets/work_exterior_after.webp", title: "Exterior Repaint — After", cat: "Exterior Painting" },
  { src: "/assets/gallery_house.webp", title: "House Painting — After", cat: "House Painting" },
  { src: "/assets/work_door_after.webp", title: "Entry Door — After", cat: "Door Refinishing" },
  { src: "/assets/gallery_deck.webp", title: "Deck Staining", cat: "Deck Staining" },
  { src: "/assets/gallery_fence.webp", title: "Cedar Fence Staining", cat: "Fence Staining" },
  { src: "/assets/kitchen_before.webp", title: "Cabinet Refinishing — Before", cat: "Cabinet Refinishing" },
  { src: "/assets/fence_before.webp", title: "Fence Staining — Before", cat: "Fence Staining" },
  { src: "/assets/work_exterior_before.webp", title: "Exterior Repaint — Before", cat: "Exterior Painting" },
  { src: "/assets/work_door_before.webp", title: "Entry Door — Before", cat: "Door Refinishing" },
];

export const TESTIMONIALS = [
  {
    slug: "thomas-razo",
    quote:
      "Teo is an exceptional painter. He was always punctual and made sure his prices matched the quality of work.",
    name: "Thomas Razo",
    meta: "Google review",
  },
  {
    slug: "lender-aguirre",
    quote:
      "He did my cabinets and let me tell you, they came out beautiful — my wife loved them. Highly recommend him, does great work.",
    name: "Lender Aguirre",
    meta: "Cabinet refinishing · Google review",
  },
  {
    slug: "ray-buyher",
    quote: "Love this contractor. Great price.",
    name: "Ray Buyher",
    meta: "Google review",
  },
  {
    slug: "kevin-white",
    quote:
      "Teo painted the outside of my house and did a great job — I was very happy with his work. He also painted the cabinets in both bathrooms.",
    name: "Kevin White",
    meta: "Exterior & cabinets · Google review",
  },
  {
    slug: "mia-mansfield",
    quote:
      "Teo has done numerous jobs for us. All have turned out great. The work is fairly priced and professional. He has turned a plain room into a work of art. The exterior painting he has done on our home and rentals went above expectations. We appreciate Teo's attention to detail. Highly recommend for any painting projects and more.",
    name: "Mia Mansfield",
    meta: "Interior & exterior · Google review",
  },
  {
    slug: "nd-munoz",
    quote: "Professional, detailed, and thorough. Teo is the best.",
    name: "N.D. Munoz",
    meta: "Google review",
  },
];

export const INSTAGRAM_URL = "https://www.instagram.com/teospaintingllc";
export const FACEBOOK_URL = "https://www.facebook.com/share/197vxnx3wB/";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CY4gR-UPTR0dEBM/review";

export const CITIES = [
  {
    slug: "reno",
    name: "RENO",
    desc: "From Somersett to South Reno — house painters Reno homeowners trust for interiors, exteriors and cabinet refinishing.",
  },
  {
    slug: "sparks",
    name: "SPARKS",
    desc: "Spanish Springs, Wingfield Springs and beyond — your local painting contractor in Sparks, NV.",
  },
  {
    slug: "carson-city",
    name: "CARSON CITY",
    desc: "From the historic district to the surrounding valleys — a painting company Carson City can rely on.",
  },
];
